import { gql } from '@apollo/client';

export const deleteAsset = gql`
    mutation deleteAsset($deleteAssetId: ID!) {
        deleteAsset(id: $deleteAssetId) {
            id
        }
    }
`;
